import script from "./lossFundReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./lossFundReport.vue?vue&type=script&setup=true&lang=ts"

import "./lossFundReport.vue?vue&type=style&index=0&id=223aaf03&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-223aaf03"]])

export default __exports__